import axiosInstance from '@/core/api'
import type { components, operations } from '@/schema'

// Query parameter types from schema
export type TTFBDistributionQuery =
	operations['AnalyticsController_getTTFBDistribution']['parameters']['query']
export type TTFDDistributionQuery =
	operations['AnalyticsController_getTTFDDistribution']['parameters']['query']
export type CohortRetentionQuery =
	operations['AnalyticsController_getCohortRetention']['parameters']['query']
export type StickinessQuery =
	operations['AnalyticsController_getStickinessTrend']['parameters']['query']
export type PlayerLifecycleQuery =
	operations['AnalyticsController_getPlayerLifecycle']['parameters']['query']

// Response types from schema
export type TTFBDistributionResponse =
	components['schemas']['TTFBDistributionResponse']
export type TTFDDistributionResponse =
	components['schemas']['TTFDDistributionResponse']
export type CohortRetentionResponse =
	components['schemas']['CohortRetentionResponse']
export type StickinessResponse =
	components['schemas']['StickinessTrendResponse']
export type PlayerLifecycleResponse =
	components['schemas']['PlayerLifecycleResponse']

export class RetentionAnalyticsService {
	static async getTTFBDistribution(
		query?: TTFBDistributionQuery,
	): Promise<TTFBDistributionResponse> {
		const { data } = await axiosInstance.get<TTFBDistributionResponse>(
			'/admin/analytics/retention/ttfb',
			{
				params: query,
			},
		)
		return data
	}

	static async getTTFDDistribution(
		query?: TTFDDistributionQuery,
	): Promise<TTFDDistributionResponse> {
		const { data } = await axiosInstance.get<TTFDDistributionResponse>(
			'/admin/analytics/retention/ttfd',
			{
				params: query,
			},
		)
		return data
	}

	static async getCohortRetention(
		query?: CohortRetentionQuery,
	): Promise<CohortRetentionResponse> {
		const { data } = await axiosInstance.get<CohortRetentionResponse>(
			'/admin/analytics/retention/cohort',
			{
				params: query,
			},
		)
		return data
	}

	static async getStickinessTrend(
		query?: StickinessQuery,
	): Promise<StickinessResponse> {
		const { data } = await axiosInstance.get<StickinessResponse>(
			'/admin/analytics/retention/stickiness',
			{
				params: query,
			},
		)
		return data
	}

	static async getPlayerLifecycle(
		query?: PlayerLifecycleQuery,
	): Promise<PlayerLifecycleResponse> {
		const { data } = await axiosInstance.get<PlayerLifecycleResponse>(
			'/admin/analytics/retention/lifecycle',
			{
				params: query,
			},
		)
		return data
	}
}
